/**
 * 匿名コンサルホットライン初回返信の共通文言
 */
export const hotlineProFirstReplyText = {
    /**
     * 項目の名前
     */
    label: {
        agenda: () => 'アドバイスに活かせる経験・実績',
        description: () => 'その他の事前確認事項',
        other: () => 'その他のメッセージ',
        similarProject: () => '相談時にアドバイスできること',
    },
};
